<template>
  <section class="project-single">
    <section-toggler :tabs="createReactLangSections"
                     :isProjectEdit="true"
                     class="toggler"
                     @toggleProjectEdit="toggleCustom($event)"
                     @toggle="toggleSec($event)"></section-toggler>
    <component :is="activeSection" component=""></component>
  </section>
</template>

<script>
  import {sectionsToggler} from "../../../mixins/utils/sectionToggler";
  import {mapMutations, mapState, mapActions} from 'vuex'
  //Четыре таба - ProjectSingle dir
  import projectRoles from '../../../components/Pages/Project/ProjectSingle/projectRoles'
  import projectThings from '../../../components/Pages/Project/ProjectSingle/projectThings'
  import projectTreeList from '../../../components/Pages/Project/ProjectSingle/projectTreeList'
  import projectSettings from './ProjectSingle/projectSettings'

  export default {
    name: "projectEditBody",
    mixins: [sectionsToggler],
    data() {
      return {
        activeSection: projectRoles,
        sections: [],
      }
    },
    watch: {
      sections() {
        return this.sections
      }
    },
    computed: {
      ...mapState({
        isFullHeader: state => state.projects.isFullHeader,
        activeHeaderTab: state => state.projects.activeHeaderTab,
        whereINeedGo: state => state.projects.whereINeedGo,
      }),
      createReactLangSections() {
        return this.sections = [
          {
            id: 0,
            name: this.$t('projects.project.sections.role') ,
            component: projectRoles,
            active: true
          },
          {
            id: 1,
            name: this.$t('projects.project.sections.things') ,
            component: projectThings,
            active: false
          },
          {
            id: 2,
            name: this.$t('projects.project.sections.section') ,
            component: projectTreeList,
            active: false,
          },
          {
            id: 3,
            name: this.$t('projects.project.sections.nodeSettings') ,
            component: projectSettings,
            active: false
          }
        ]
      }
    },
    methods: {
      ...mapMutations({
        setSettingsActiveTab: 'projects/SET_FULL_HEADER',
        setSettingsNodeEditable: 'projects/SET_SETTINGS_NODE_EDITABLE',
        setHeaderSettingsEditActive: 'projects/SET_HEADER_SETTINGS_EDIT_ACTIVE',
        setActiveTab: 'projects/SET_ACTIVE_HEADER_TAB',
        setWhereINeedGo: 'projects/SET_WHERE_I_NEED_GO'
      }),
      setEditableNodeSettings(val) {
        this.setSettingsNodeEditable(val);
        this.setHeaderSettingsEditActive(val)
      },
      toggleCustom(tab) {
        this.toggleSec(tab);

        if(tab.index === 3) {
          this.setSettingsActiveTab(true)
        } else {
          this.setSettingsActiveTab(false)
          this.setHeaderSettingsEditActive(false)
          this.setEditableNodeSettings(false)
        }

        this.setActiveTab(tab.tab.name)
      }
    },
    mounted() {
      //если перешли сразу на конкретный таб из карточек проектов
      if (this.whereINeedGo !== '') {
        if (this.whereINeedGo === 'projectThings') {
          this.toggleCustom({index: 0, tab: projectRoles})
        }
        if (this.whereINeedGo === 'projectThings') {
          this.toggleCustom({index: 1, tab: projectThings})
        }
        if (this.whereINeedGo === 'projectTreeList') {
          this.toggleCustom({index: 2, tab: projectTreeList})
        }
        if (this.whereINeedGo === 'projectSettings') {
          this.toggleCustom({index: 3, tab: projectSettings})
        }
        this.setWhereINeedGo('')
        //просто переключение активности табов
      } else {
        let val = this.activeHeaderTab;
        switch (val) {
          case('projectRoles'): this.toggleCustom({index: 0, tab: projectRoles});
            break;
          case('projectThings'): this.toggleCustom({index: 1, tab: projectThings});
            break;
          case('projectTreeList'): this.toggleCustom({index: 2, tab: projectTreeList});
            break;
          case('projectSettings'): this.toggleCustom({index: 3, tab: projectSettings});
            break;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /*.project-single {*/
  /*  padding: 20px 30px;*/
  /*}*/
  .toggler {
    border-bottom: 1px solid $grey;
    /*margin: 0 5px;*/
    margin-left: 1px;

  }
  /*.project-single {*/
  /*  padding-bottom: 0;*/
  /*}*/
  .section-toggler {
    margin-bottom: 0;
    /*border-bottom: 1px solid red;*/
    padding: 20px 20px 0 20px;
  }
</style>
